import { useQuery } from "react-query";
import { getAuthUrls } from "../../network/apis/auth";
import { QUERIES } from "../../utils/constants";

export const useAuthUrls = () => {
  return useQuery(QUERIES.LOAD_SLACK_AUTH_URLS, getAuthUrls, {
    staleTime: Infinity
  });
};
